import { Checkbox, CheckboxProps, Collapse, Input, Spin } from 'antd'
import React, { useContext, useEffect, useMemo, useState } from 'react'

import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';

//styles
import "./ProductFilters.css"
import { Category } from '../../models/Category'
import { Franchise } from '../../models/Franchise'
import { getAllCategories } from '../../api/Categories'
import { PromiseSesionContext } from '../../machines/ErrorMachine'
import { getAllFranchises } from '../../api/Franchises'
import { GlobalContext } from '../../context/GlobalContext'

interface Props{
   filterCategory:string[]
   setFilterCategory: React.Dispatch<React.SetStateAction<string[]>>
   filterFranchises:string[]
   setFilterFranchises: React.Dispatch<React.SetStateAction<string[]>>
   filterStatus:string[]
   setFilterStatus:React.Dispatch<React.SetStateAction<string[]>>

   loadingProducts:boolean

}

const ProductFilters = ({ filterFranchises, setFilterFranchises, filterStatus, setFilterStatus,loadingProducts, filterCategory, setFilterCategory}:Props) => {

    const [searchTerm, setSearchTerm] = useState<string>('');
    const {sendError} = useContext(PromiseSesionContext);

    const { categories, franchises, loading } = useContext(GlobalContext);

    const filteredFranchises = useMemo(() => {
        return franchises.filter((f: Franchise) =>
          f.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }, [searchTerm, franchises]);
    
    const onChangeCategory: CheckboxProps['onChange'] = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFilterCategory(prev => [...prev, value]);
    } else {
      setFilterCategory(prev => prev.filter(item => item !== value));
    }
  };

    const onChangeFranchise: CheckboxProps['onChange'] = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFilterFranchises(prev => [...prev, value]);
    } else {
      setFilterFranchises(prev => prev.filter(item => item !== value));
    }
    };

  const onChangeStatus: CheckboxProps['onChange'] = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFilterStatus(prev => [...prev, value]);
    } else {
      setFilterStatus(prev => prev.filter(item => item !== value));
    }
  };
  
  return (
    <div className='filter-Products-container'>
          <div className='filter-products-section'>
            <Collapse
            // style={{background:"transparent"}}

            bordered={false}
              defaultActiveKey={['1']}
            items={[{ key: '1', label: <>Categorías {(loading && loadingProducts) && <Spin indicator={<LoadingOutlined spin />} size="small" />}</>, children: <div className='filter-products-elements' > 
                    {categories.map((category:Category)=> <Checkbox key={`Categoria ${category.id}`} value={category.id} onChange={onChangeCategory} disabled={loading && loadingProducts} >{category.name}</Checkbox>)}
                
            </div> }]}
            />
        </div>
        <div className='filter-products-section'>
            <Collapse
            // style={{background:"transparent"}}
              bordered={false}
              defaultActiveKey={['1']}
            items={[{ key: '1', label: <>Grupo {(loading && loadingProducts) && <Spin indicator={<LoadingOutlined spin />} size="small" />}</>, children: <div className='filter-products-elements' > 
              {(!loading) && <Input
                  placeholder="Buscar franquicia..."
                  prefix={<SearchOutlined />}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ marginBottom: 12, borderRadius: '6px' }}
                  allowClear
                />}
                {filteredFranchises.map((franchise:Franchise)=> <Checkbox key={`Franquicia ${franchise.id}`} value={franchise.id} onChange={onChangeFranchise} disabled={loading && loadingProducts} >{franchise.name}</Checkbox>)}


            </div> }]}
            />
        </div>

        {/* <div className='filter-products-section'>
            <Collapse
            bordered={false}
            style={{background:"transparent"}}

            defaultActiveKey={['1']}
            items={[{ key: '1', label: 'Estatus', children: <div className='filter-products-elements'> 
                <Checkbox value={"available"} onChange={onChangeStatus} disabled={loading}>Disponible</Checkbox>
                <Checkbox value={"soon"} onChange={onChangeStatus} disabled={loading}>Proximamente</Checkbox>
                <Checkbox value={"sould out"} onChange={onChangeStatus} disabled={loading}>Agotado</Checkbox>
            </div> }]}
            />
        </div> */}


     

    </div>
  )
}

export default ProductFilters